var render = function render(){var _vm=this,_c=_vm._self._c;return _c('draggable',{staticClass:"stream-nested-draggable",attrs:{"tag":"div","group":_vm.group,"list":_vm.draggableComponents,"draggable":_vm.draggable,"scroll-sensitivity":200,"move":_vm.onDragMove},on:{"end":_vm.onDragEnd}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }